import { InjectionToken } from '@angular/core';

export const API_KEY = new InjectionToken<string>('Google Maps API key');
